import React from 'react'
import leaf from "src/assets/images/icon-leaf-black.png";
import leafadd from "src/assets/images/rohs_10_compliant.png";
import save from "src/assets/images/save.png";
import EndOfLifeOFlagImage from "src/assets/images/eol.png";
import noncancel from "src/assets/images/icon-non-cancel-black.png";
import shape from "src/assets/images/shape.png";
import ban from "src/assets/images/ban.png";
import designhub from "src/assets/images/designhub-ledgend-icon.png";
import cut from "src/assets/images/cut.png";
import new_product from "src/assets/images/highlighter.png";
import online from "src/assets/images/online.png";
import rohs_exempt from "src/assets/images/rohs_10_exempt.png";
import top_seller from "src/assets/images/star.png";
import eol from "src/assets/images/eol.png";
import cross_round from "src/assets/images/cross-round.png";
import { Tooltip } from 'src/component/Tooltip';
import Product from "@system/config/product";
const ProductLegends = (props) => {
    const { single_product, onlyIcon, onlyIconTitle } = props;

    const renderLegendIcon = (iconPath, message, showIcon) => {

        return (
            showIcon === true ?
                (
                    <>
                        <span className="list-text-icon"><img className="img-fluid me-1" alt="Legend Information Icon" src={iconPath} /></span>
                    </>
                ) :
                (
                    <>
                        <Tooltip
                            position={'bottom left'}
                            opener={() => (
                                <span className="list-text-icon"><img
                                    className="img-fluid me-1" alt="Legend Information Icon"
                                    src={iconPath} /></span>
                            )}
                            content={() => (
                                message
                            )}
                        />
                    </>
                )
        )
    };

    const getROHSCompliantValueByCode = (ROHSCompliantCode) => {
        if(ROHSCompliantCode!==undefined && ROHSCompliantCode!== null && ROHSCompliantCode!=='')
            {
                if(single_product.ROHSCompliantCodeValue === undefined)
                {
                    return Product.product__ROHSCompliantCode(ROHSCompliantCode);
                }
                return single_product.ROHSCompliantCodeValue;
            }
            return ROHSCompliantCode;
    }
    return (
        <>
            {single_product !== undefined &&
                <>
                    {/*RoHS Complaint */}
                    {single_product.ROHSCompliantCode !== undefined && single_product.ROHSCompliantCode !== null && (single_product.ROHSCompliantCode.toUpperCase() === 'Y' ||
                        single_product.ROHSCompliantCode.toUpperCase() === 'C') &&
                        <li>
                            {(onlyIcon !== undefined && onlyIcon !== null && onlyIcon === true) &&
                                <>
                                    {renderLegendIcon((single_product.ROHSCompliantCode.toUpperCase() === 'Y' ? leaf : leafadd), getROHSCompliantValueByCode(single_product.ROHSCompliantCode), false)}
                                </>
                            }
                            {(onlyIconTitle !== undefined && onlyIconTitle !== null && onlyIconTitle === true) &&
                                <>
                                    {renderLegendIcon((single_product.ROHSCompliantCode.toUpperCase() === 'Y' ? leaf : leafadd), '', true)}
                                    <span>{single_product.ROHSCompliantCodeValue}</span>
                                </>
                            }
                        </li>
                    }
                    {/* RoHS Non-Complaint */}
                    {single_product.ROHSCompliantCode !== undefined && single_product.ROHSCompliantCode !== null && single_product.ROHSCompliantCode.toUpperCase() === 'N' &&
                        <li>
                            {onlyIcon !== undefined && onlyIcon !== null && onlyIcon === true &&
                                <>
                                    {renderLegendIcon(ban, getROHSCompliantValueByCode(single_product.ROHSCompliantCode), false)}
                                </>
                            }
                            {onlyIconTitle !== undefined && onlyIconTitle !== null && onlyIconTitle === true &&
                                <>
                                    {renderLegendIcon(ban, '', true)}
                                    <span>{single_product.ROHSCompliantCodeValue}</span>
                                </>
                            }
                        </li>
                    }
                    {/* RoHS Exempt */}
                    {single_product.ROHSCompliantCode !== undefined && single_product.ROHSCompliantCode !== null && (single_product.ROHSCompliantCode.toUpperCase() === 'E' ||
                        single_product.ROHSCompliantCode.toUpperCase() === 'X') &&
                        <li>
                            {(onlyIcon !== undefined && onlyIcon !== null && onlyIcon === true) &&
                                <>
                                    {renderLegendIcon((single_product.ROHSCompliantCode.toUpperCase() === 'E' ? rohs_exempt : cross_round), getROHSCompliantValueByCode(single_product.ROHSCompliantCode), false)}
                                </>
                            }
                            {(onlyIconTitle !== undefined && onlyIconTitle !== null && onlyIconTitle === true) &&
                                <>
                                    {renderLegendIcon((single_product.ROHSCompliantCode.toUpperCase() === 'E' ? rohs_exempt : cross_round), '', true)}
                                    <span>{single_product.ROHSCompliantCodeValue}</span>
                                </>
                            }
                        </li>
                    }
                    {/**
                     * Ticket #  : 9038
                     * Change #  : NCNR Tooltip text change
                     * Change By : Pankaj
                     * Date      : 01 Feb 2023
                     */}
                    {/* NCNR Flag */}
                    {single_product.NCNRFlag &&
                        <li>
                            {(onlyIcon !== undefined && onlyIcon !== null && onlyIcon === true) &&
                                <>
                                    {renderLegendIcon(noncancel, 'Non-Cancelable, Non-Returnable', false)}
                                </>
                            }
                            {(onlyIconTitle !== undefined && onlyIconTitle !== null && onlyIconTitle === true) &&
                                <>
                                    {renderLegendIcon(noncancel, '', true)}
                                    <span>Non-Cancelable, Non-Returnable</span>
                                </>
                            }
                        </li>
                    }
                    {/* Cut Tape */}
                    {single_product.PackagingTypeCode !== undefined && single_product.PackagingTypeCode !== null && (single_product.PackagingTypeCode.toUpperCase() === 'BKN' ||
                        single_product.PackagingTypeCode.toUpperCase() === 'CST') &&
                        <li>
                            {onlyIcon !== undefined && onlyIcon !== null && onlyIcon === true &&
                                <>
                                    {renderLegendIcon(cut, 'Cut Tape', false)}
                                </>
                            }
                            {onlyIconTitle !== undefined && onlyIconTitle !== null && onlyIconTitle === true &&
                                <>
                                    {renderLegendIcon(cut, '', true)}
                                    <span>Cut Tape</span>
                                </>
                            }
                        </li>
                    }
                    {/* Web Only */}
                    {single_product.WebOnlyFlag !== undefined && single_product.WebOnlyFlag !== null && single_product.WebOnlyFlag.toLowerCase() === 'yes' &&
                        <li className="obsolete-popup">
                            {onlyIcon !== undefined && onlyIcon !== null && onlyIcon === true &&
                                <>
                                    {renderLegendIcon(online, 'On-line', false)}
                                </>
                            }
                            {onlyIconTitle !== undefined && onlyIconTitle !== null && onlyIconTitle === true &&
                                <>
                                    {renderLegendIcon(online, '', true)}
                                    <span>On-line</span>
                                </>
                            }
                        </li>
                    }
                    {/* New Product */}
                    {single_product.NPIFlag !== undefined && single_product.NPIFlag !== null && single_product.NPIFlag.toLowerCase() === 'yes' &&
                        <li className="obsolete-popup">
                            {onlyIcon !== undefined && onlyIcon !== null && onlyIcon === true &&
                                <>
                                    {renderLegendIcon(new_product, 'New Product', false)}
                                </>
                            }
                            {onlyIconTitle !== undefined && onlyIconTitle !== null && onlyIconTitle === true &&
                                <>
                                    {renderLegendIcon(new_product, '', true)}
                                    <span>New Product</span>
                                </>
                            }
                        </li>
                    }
                    {/* Obsolete Flag */}
                    {single_product.ObsoleteFlag &&
                        <li className='obsolete-popup'>
                            {onlyIcon !== undefined && onlyIcon !== null && onlyIcon === true &&
                                <>
                                    {renderLegendIcon(save, 'Obsolete', false)}
                                </>
                            }
                            {onlyIconTitle !== undefined && onlyIconTitle !== null && onlyIconTitle === true &&
                                <>
                                    {renderLegendIcon(save, '', true)}
                                    <span>Obsolete</span>
                                </>
                            }
                        </li>
                    }
                    {/* Top Seller Flag */}
                    {single_product.TopSellerFlag !== undefined && single_product.TopSellerFlag !== null && single_product.TopSellerFlag.toLowerCase() === 'yes' &&
                        <li>
                            {onlyIcon !== undefined && onlyIcon !== null && onlyIcon === true &&
                                <>
                                    {renderLegendIcon(top_seller, 'Top Seller', false)}
                                </>

                            }
                            {onlyIconTitle !== undefined && onlyIconTitle === true &&
                                <>
                                    {renderLegendIcon(top_seller, '', true)}
                                    <span>Top Seller</span>
                                </>
                            }
                        </li>
                    }
                    {/* End Of Life Flag */}
                    {single_product.EndOfLifeFlag &&
                        <li>
                            {onlyIcon !== undefined && onlyIcon !== null && onlyIcon === true &&
                                <>
                                    {renderLegendIcon(eol, 'End Of Life', false)}
                                </>
                            }
                            {onlyIconTitle !== undefined && onlyIconTitle === true &&
                                <>
                                    {renderLegendIcon(eol, '', true)}
                                    <span>End Of Life</span>
                                </>
                            }
                        </li>
                    }

                     {/* End Of Life Flag */}
                     {single_product?.IsDesignsAvailable &&
                        <li>
                            {onlyIcon !== undefined && onlyIcon !== null && onlyIcon === true &&
                                <>
                                    {renderLegendIcon(designhub, 'Design Available', false)}
                                </>
                            }
                            {onlyIconTitle !== undefined && onlyIconTitle === true &&
                                <>
                                    {renderLegendIcon(designhub, '', true)}
                                    <span>Design Available</span>
                                </>
                            }
                        </li>
                    }
                </>
            }
        </>
    )
}

export default ProductLegends